import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "../styles/about.css";
import king from "../assets/images/king.png";
import pawn from "../assets/images/WPawn.png";
import timeline from "../assets/images/timeline_2.png";
import t1 from "../assets/images/carousel5.jpeg"
import t2 from "../assets/images/carousel12.jpeg"
import t3 from "../assets/images/carousel1.jpeg"
import t4 from "../assets/images/carousel13.jpeg"
import t5 from "../assets/images/carousel6.jpeg"
import t6 from "../assets/images/carousel15.jpg"
import { API_CONFIG } from "../config/api";
import { generateAuthToken, generateURN } from "../components/hmac";
import {
  welcome_message,
  about_us,
  why_chess,
  what_we_do
} from "../data/aboutData";

const About = () => {
  const pawnRef = useRef(null);
  const [isPawnVisible, setIsPawnVisible] = useState(false);
  const location = useLocation();        // ✅ NEW
  const demoSectionRef = useRef(null);   // ✅ NEW


  useEffect(() => {
  if (location.state?.isModalOpen) {
    setIsModalOpen(true);
    window.history.replaceState({}, document.title);
  }
}, [location.state]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsPawnVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (pawnRef.current) observer.observe(pawnRef.current);
    return () => observer.disconnect();
  }, []);
  /* =========================
   AUTO OPEN DEMO ON REDIRECT
========================= */
useEffect(() => {
  if (location.state?.scrollToDemo) {
    setIsDemoOpen(true);

    setTimeout(() => {
      demoSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 300);
  }
}, [location]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  // 1. Add 'isDemoOpen' to your state at the top of the component
const [isDemoOpen, setIsDemoOpen] = useState(false);
const [demoForm, setDemoForm] = useState({
  name: "",
  userEmail: "",
  contactNo: "",
  preferredDay: "",
  preferredTimeslot: ""
});

const [demoLoading, setDemoLoading] = useState(false);
const [demoMessage, setDemoMessage] = useState("");

const [contactForm, setContactForm] = useState({
  name: "",
  userEmail: "",
  inquiryType: "",
  message: ""
});

const [contactLoading, setContactLoading] = useState(false);
const [contactMessage, setContactMessage] = useState("");



const toggleDemoModal = () => {
  setIsDemoOpen(!isDemoOpen);
};

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const handleDemoChange = (e) => {
  const { name, value } = e.target;
  setDemoForm((prev) => ({
    ...prev,
    [name]: value
  }));
};

const handleDemoSubmit = async (e) => {
  e.preventDefault();
  setDemoLoading(true);
  setDemoMessage("");

  try {
    const { host, sendDemoRegisteration,basic } = API_CONFIG;
    const urn=generateURN();
    const authToken=generateAuthToken(urn);
    const res = await fetch(`https://${host}${sendDemoRegisteration.path}`,
      {
        method: sendDemoRegisteration.method,
        headers: { 
          "Content-Type": "application/json",
           Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
           urn:urn,
           authToken:authToken,
        },
        body: JSON.stringify(demoForm)
      }
    );
    const json=await res.json();
    const data=json.apiResponseData;

    if (data.responseCode === "200") {
      setDemoMessage(data.responseMessage);
      setDemoForm({
        name: "",
        userEmail: "",
        contactNo: "",
        preferredDay: "",
        preferredTimeslot: ""
      });
      setTimeout(() => setIsDemoOpen(false), 1500);
    } else {
      setDemoMessage("Something went wrong. Try again.");
    }
  } catch (err) {
    setDemoMessage("Server error. Please try later.");
  } finally {
    setDemoLoading(false);
  }
};

const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({
    ...prev,
    [name]: value
  }));
};

const handleContactSubmit = async (e) => {
  e.preventDefault();
  setContactLoading(true);
  setContactMessage("");

  try {
    const { host,contactUs,basic } = API_CONFIG;
    const urn=generateURN();
    const authToken=generateAuthToken(urn);
    const res = await fetch(`https://${host}${contactUs.path}`,{
      method: contactUs.method,
      headers: { 
        "Content-Type": "application/json",
        Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
        urn:urn,
        authToken:authToken
       },
      body: JSON.stringify(contactForm)
    });

    const json=await res.json();
    const data=json.apiResponseData;
    if (data.responseCode === "200") {
      setContactMessage("Thank you for reaching us Email sent successfully.We will get back to you shortly!");
      setContactForm({
        name: "",
        userEmail: "",
        inquiryType: "",
        message: ""
      });
      setTimeout(() => setIsModalOpen(false), 1500);
    } else {
      setContactMessage("Failed to send message. Try again.");
    }
  } catch (err) {
    setContactMessage("Server error. Please try later.");
  } finally {
    setContactLoading(false);
  }
};

  // Replace these IDs with your actual YouTube Video IDs
  const vlogs = [
    { id: "ukcPGdxWqHE", title: "Tournament Vlog" },
    { id: "sNKRA-vhI2k", title: "Training Sessions" },
    { id: "_b87Izfz_iI", title: "Behind the Scenes" }
  ];

  return (
    <main className="about-page-wrapper">
      {/* 1. HERO SECTION */}
      <section className="intro">
        <h1 className="main-text">
          {welcome_message.heading.split(' ').map((word, i) => 
            word.toLowerCase() === "kings" ? <span key={i}>{word} </span> : word + " "
          )}
        </h1>
        <div className="welcome">
          <p>{welcome_message.text}</p>
        </div>
        <img className="king-piece" src={king} alt="Chess King" />
      </section>

      {/* 2. ABOUT & FOUNDER SECTION */}
      <section className="about-details"> 
        <div className="container">
          <h1 id="about-title">ABOUT US</h1>
          <div className="about-split-layout single-column">
          <div className="about-story-side">
            <p className="description-text">{about_us.description}</p>

            <div className="why-chess-card">
              <img
                ref={pawnRef}
                className={`pawn-decor-floating ${isPawnVisible ? "animate-pawn" : ""}`}
                src={pawn}
                alt="pawn"
              />
              <h3>{why_chess.title}</h3>
              <ul className="premium-check-list">
                {why_chess.points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        </div>
      </section>

   {/* 3. PREMIUM TOURNAMENT SCRAPBOOK GALLERY */}
<section className="tournament-section">
  <div className="container">
    <div className="scrapbook-header">
      <h2 className="section-header">Tournaments & Moments</h2>
      <div className="header-underline"></div>
    </div>
    
    <div className="scrapbook-container">
      {/* Column 1: Scattered Images */}
      <div className="scrapbook-column col-left">
        <div className="scrapbook-item polaroid rotate-left">
          <img src={t1} alt="State Championship" />
          <div className="pin"></div>
        </div>
        <div className="scrapbook-item frame-gold shadow-deep">
          <img src={t2} alt="Junior Chess" />
        </div>
      </div>

      {/* Column 2: The Main Highlights */}
      <div className="scrapbook-column col-center">
        <div className="scrapbook-item simple-frame rotate-right">
          <img src={t3} alt="Award Ceremony" />
        </div>
        <div className="scrapbook-item polaroid-wide">
          <img src={t4} alt="Workshop" />
          <div className="tape"></div>
        </div>
      </div>

      {/* Column 3: The Finishers */}
      <div className="scrapbook-column col-right">
        <div className="scrapbook-item frame-dark rotate-left">
          <img src={t5} alt="Inter-school" />
        </div>
        <div className="scrapbook-item polaroid rotate-right">
          <img src={t6} alt="ChessWizzania Open" />
          <div className="pin gold-pin"></div>
        </div>
      </div>
    </div>
  </div>
</section>
      {/* 4. WHAT WE DO (Timeline Alignment Corrected) */}
      <section className="what-we-do-section">
        <div className="container">
          <h1 className="white-title-center">{what_we_do.title}</h1>
          <div className="timeline-container">
            <img src={timeline} alt="timeline steps" className="timeline-image" />
            <div className="timeline-grid">
              {what_we_do.items.map((item, index) => (
                <div className="timeline-card" key={index}>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 5. CONTACT & DEMO CTA */}
      <section className="contact-cta" ref={demoSectionRef}>
        <div className="cta-box-glass">
          <h2>Ready to start your journey?</h2>
          <p>Book a free demo session or reach out to us for queries.</p>
          <div className="cta-group">
           <button className="gold-btn-shiny" onClick={toggleDemoModal}>Register for Demo</button>
            <button className="outline-btn-gold" onClick={toggleModal}>Contact Us</button>
          </div>
        </div>
      </section>

      {/* 6. VLOG CAROUSEL (Updated with YouTube Embeds) */}
      <section className="vlog-footer-area">
        <div className="container">
          <h2 className="section-header">Behind the Scenes</h2>
          <div className="vlog-grid">
            {vlogs.map((vlog, index) => (
              <div className="vlog-card-item" key={index}>
                <iframe
                  width="100%"
                  height="100%"
                  src={`https://www.youtube.com/embed/${vlog.id}`}
                  title={vlog.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT MODAL POPUP */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={toggleModal}>&times;</button>
            <h2 className="modal-title">Get in Touch</h2>
            <p>Fill out the form below and we'll get back to you shortly.</p>
            <form className="contact-form" onSubmit={handleContactSubmit}>
              <input
                type="text"
                name="name"
                value={contactForm.name}
                onChange={handleContactChange}
                placeholder="Full Name"
                required
              />
              <input
                type="email"
                name="userEmail"
                value={contactForm.userEmail}
                onChange={handleContactChange}
                placeholder="Email Address"
                required
              />
                            <select
                  name="inquiryType"
                  value={contactForm.inquiryType}
                  onChange={handleContactChange}
                  required
                >
                <option value="">Inquiry Type</option>
                <option value="tournament">Tournament Info</option>
                <option value="coaching">Coaching Classes</option>
                <option value="other">Other</option>
              </select>
              <textarea
                name="message"
                value={contactForm.message}
                onChange={handleContactChange}
                placeholder="Your Message"
                rows="4"
                required
              />
              {contactMessage && <p className="form-message">{contactMessage}</p>}
              <button
              type="submit"
              className="gold-btn-shiny"
              disabled={contactLoading}
              >
              {contactLoading ? "Sending..." : "Send Message"}
            </button>

            </form>
          </div>
        </div>
      )}
      {isDemoOpen && (
  <div className="modal-overlay" onClick={toggleDemoModal}>
    <div className="modal-content demo-modal" onClick={(e) => e.stopPropagation()}>
      <button className="close-modal" onClick={toggleDemoModal}>&times;</button>
      <h2 className="modal-title">Book a Free Demo</h2>
      <p>Master the game with a personalized session. Tell us your preference!</p>
      
      <form className="contact-form" onSubmit={handleDemoSubmit}>
      <input
        type="text"
        name="name"
        value={demoForm.name}
        onChange={handleDemoChange}
        placeholder="Your Full Name"
        required
      />
      <input
        type="email"
        name="userEmail"
        value={demoForm.userEmail}
        onChange={handleDemoChange}
        placeholder="Email Address"
        required
      />
      <input
        type="tel"
        name="contactNo"
        value={demoForm.contactNo}
        onChange={handleDemoChange}
        placeholder="Contact Number (WhatsApp preferred)"
        required
      />      
      <div className="form-row-split">
      <select
        name="preferredDay"
        value={demoForm.preferredDay}
        onChange={handleDemoChange}
        required
      >
        <option value="">Preferred Day</option>
        <option value="weekdays">Weekdays</option>
        <option value="weekend">Weekend</option>
      </select>
    
      <select
        name="preferredTimeslot"
        value={demoForm.preferredTimeslot}
        onChange={handleDemoChange}
        required
      >

            <option value="">Preferred Time Slot</option>
            <option value="morning">Morning (10 AM - 12 PM)</option>
            <option value="afternoon">Afternoon (2 PM - 5 PM)</option>
            <option value="evening">Evening (6 PM - 9 PM)</option>
          </select>
        </div>
        {demoMessage && <p className="form-message">{demoMessage}</p>}
        <button
          type="submit"
          className="gold-btn-shiny"
          disabled={demoLoading}
        >
          {demoLoading ? "Submitting..." : "Confirm Registration"}
        </button>
      </form>
    </div>
  </div>
      )}
    </main>
  );
};
export default About;